var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCirleBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365966",
    "data-name": "Path 365966",
    d: "M23.044,21.491l-3.621-3.621,3.621-3.621A1.1,1.1,0,0,0,21.492,12.7l-3.621,3.621L14.25,12.7A1.1,1.1,0,0,0,12.7,14.25l3.621,3.621L12.7,21.491a1.062,1.062,0,0,0,0,1.553,1.091,1.091,0,0,0,1.553,0l3.621-3.621,3.621,3.621a1.1,1.1,0,0,0,1.553,0A1.091,1.091,0,0,0,23.044,21.491Z",
    transform: "translate(-2.494 -2.493)",
    fill: "#005899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365967",
    "data-name": "Path 365967",
    d: "M15.375,4.99a10.381,10.381,0,1,1-7.344,3.04,10.316,10.316,0,0,1,7.344-3.04m0-1.615a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z",
    transform: "translate(0)",
    fill: "#005899"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCirleBtn);
export default __webpack_public_path__ + "static/media/close-cirle-btn.3086cb91865b448b83cf84b7e3be57a7.svg";
export { ForwardRef as ReactComponent };